export const environment = {
  app_name: 'fibr',
  buildConfiguration: 'development',
  version: '0.0.1-MPV',
  localization: 'en',
  apiEndpoint: 'fibr',
  logo: 'assets/images/logo_appfibr.svg',
  logo_right: '/assets/logo_appfibr-w.svg',
  logo_footer: '/assets/logo_fibr_footer.svg',
  image_login: '/assets/images/img_login-forgot-fibr-new.jpg',
  image_register: '/assets/images/img_register-fibr-new.jpg',
  image_forgotPassword: '/assets/images/img_login-forgot-fibr-new.jpg',
  isGoogleSignIn: true,
  isAppleSignIn: true,
  isMicrosoftSignIn: true,
  registerNameLabel_en: 'Full Name',
  registerNameLabel_id: 'Nama Lengkap',
  role: 'partner',
  role_id: 'wzbcwFfUZF3Li2buWD6b',
  nextStage: { isNextPage: false, url: '', queryParams: {} },
  template_sample_data : 'ON1KIIgqRslEr1TsgfXe',
  topbar: {
    isNotif: true,
    isLanguage: true,
    isHelp: true,
    isGreeting: false,
    isProfile: true,
  },
  addPackage: {
    max_rows_free: 100,
    max_rows_paid: 5000,
    max_page_free: 3,
    max_page_paid: 10,
    max_table_free: 3,
    max_table_paid: 20,
    min_upload: 512000,
    max_upload: 20480000,
    max_etc_upload: 2048000,
  },
  login_right: {
    h4: 'Create Your App Without Code!',
    h4_register: 'Create an Account',
    h4_forgotPassword: 'Oops... Forgot your password?',
    h4_admin: 'Simple! Start with AppFibr',
    p: 'Simply! Just prepare your data with Google Sheets, import it to our dashboard, then you can easily create and customize your own mobile app.\r\nLet`s having fun and creative on making any apps with us!',
    p_admin:
      "It's easy to create your own apps. Let's have fun on making any apps with us!",
  },
  config: {
    app_name: 'fibr',
    login_style: 1,
    background_image: '',
    username: 'fadjrin@gmail.com',
    password: '123456',
  },
  gradient: ['#8DE4EA', '#084B83'],
  primary_button_color: '#4394D8',
  text_color: '#479DB8',
  firebase: {
    apiKey: 'AIzaSyAQH2V0QYcNox0sunNt4a5cjGP0P_CNIEQ',
    authDomain: 'appfibr-auth-dev.firebaseapp.com',
    projectId: 'appfibr-auth-dev',
    storageBucket: 'appfibr-users-bucket',
    messagingSenderId: '309067965444',
    appId: '1:309067965444:web:ec08e255b2efd8d5400151',
    measurementId: 'G-762ZVMVD7B',
  },
  firebase2: {
    apiKey: 'AIzaSyCcAHfnW5k8IHfFMq7056ZQnfT5jbGP_Mg',
    authDomain: 'appfibr-projects-dev.firebaseapp.com',
    projectId: 'appfibr-projects-dev',
    storageBucket: 'appfibr-bucket-dev',
    messagingSenderId: '944939578857',
    appId: '1:944939578857:web:5085a329e71e331ad08778',
    measurementId: 'G-JW10JPFPSR',
  },
  apiUrl: 'https://asia-southeast2-appfibr-auth-dev.cloudfunctions.net',
  apiProjectUrl: 'https://asia-southeast2-appfibr-projects-dev.cloudfunctions.net',
  previewUrl: 'https://appfibr-projects-dev.web.app',
  play_store_app : 'https://play.google.com/store/apps',
  app_store_app : 'https://apps.apple.com/us/app/',

  recaptcha: {
    siteKey: '6LffdIEpAAAAAD1Q8GSN5nzF1wDCQCymxqDRS-EG',
  },
  flutterBundleVersion: '001',
  flutterAssetUrl: 'https://storage.googleapis.com/appfibr-admin-dev.appspot.com/flutter-preview/dev/',
  googleClientID : '944939578857-29v6i64dkmrr9mfv8eksjj8p88bb0upu.apps.googleusercontent.com',
  googleApiKey : 'AIzaSyCcAHfnW5k8IHfFMq7056ZQnfT5jbGP_Mg',
  mixpanel:{
    token: '88f6cea7a9919edf7295194c7d73c826',
  },
};
